import * as React from 'react';
import * as style from './style.css';
import { Image, UIHeading4, UIText2 } from '@cian/ui-kit';
import { Features } from '../Features';
import { EOffersClickAction } from '../../../../types/tracking';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var Card = function Card(_ref) {
  var layout = _ref.layout,
    onClick = _ref.onClick,
    trackLayoutModalOpen = _ref.trackLayoutModalOpen,
    isLayoutModalDisabled = _ref.isLayoutModalDisabled,
    trackListingLinkClick = _ref.trackListingLinkClick;
  var onCardClick = function onCardClick(event) {
    if (isLayoutModalDisabled) {
      trackListingLinkClick(EOffersClickAction.fromDeveloper);
      return;
    }
    event.preventDefault();
    onClick(layout.layoutKey);
    trackLayoutModalOpen();
  };
  return /*#__PURE__*/_jsxs("a", {
    href: layout.offersUrl,
    className: style['container'],
    onClick: onCardClick,
    target: "_blank",
    rel: "noreferrer",
    children: [/*#__PURE__*/_jsxs("div", {
      className: style['image'],
      children: [/*#__PURE__*/_jsx(Image, {
        src: layout.image,
        alt: "\u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B",
        objectFit: "contain"
      }), /*#__PURE__*/_jsx(Features, {
        features: layout.features
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: style['description'],
      children: [/*#__PURE__*/_jsx("div", {
        className: style['description__room_type'],
        children: /*#__PURE__*/_jsx(UIText2, {
          children: layout.roomTypeDisplay
        })
      }), /*#__PURE__*/_jsx(UIHeading4, {
        children: layout.totalAreaDisplay
      }), /*#__PURE__*/_jsx(UIText2, {
        children: layout.priceRangeDisplay
      }), /*#__PURE__*/_jsx("div", {
        className: style['description__controls'],
        children: /*#__PURE__*/_jsx(UIText2, {
          color: "primary_100",
          children: layout.offersCountDisplay
        })
      })]
    })]
  });
};